import { StyledTableBody } from 'Components/TableBase/Table';
import React, { FC } from 'react';
import ImpactClaimTableRow from './ImpactClaimTableRow';
import ImpactGroupTableRow from './ImpactGroupTableRow';
import { ImpactClaim } from 'FeatureModules/Request/types/impactClaim.types';
import { TableAction } from './ImpactClaimTable';

interface IImpactClaimTableBodyProps {
  impactClaims: ImpactClaim[];
  actions?: TableAction[];
  displayGroup?: boolean;
  onSelect: (id: string) => void;
  'data-testId'?: string;
}

export interface IImpactClaimGroup {
  impactCatalogItemId: string;
  impactClaims: ImpactClaim[];
}

const ImpactClaimTableBody: FC<IImpactClaimTableBodyProps> = ({
  impactClaims,
  displayGroup,
  actions,
  onSelect,
  'data-testId': dataCy = '',
}) => {
  // group impact claims by impact catalog item id
  const impactClaimGroups = impactClaims.reduce((acc, impactClaim) => {
    const existingGroup = acc.find(
      group => group.impactCatalogItemId === impactClaim.impactCatalogItem.id
    );

    if (existingGroup) {
      existingGroup.impactClaims.push(impactClaim);
    } else {
      acc.push({
        impactCatalogItemId: impactClaim.impactCatalogItem.id,
        impactClaims: [impactClaim],
      });
    }

    return acc;
  }, [] as IImpactClaimGroup[]);

  return (
    <StyledTableBody data-testid={dataCy}>
      {impactClaimGroups.map((impactClaimGroup, index) => {
        const isGroup = impactClaimGroup.impactClaims.length > 1 && displayGroup;

        if (isGroup) {
          return (
            <ImpactGroupTableRow
              key={index}
              impactClaimGroup={impactClaimGroup}
              actions={actions}
              onSelect={onSelect}
            />
          );
        } else {
          return impactClaimGroup?.impactClaims.map((impactClaim, index) => (
            <ImpactClaimTableRow
              key={index}
              impactClaim={impactClaim}
              hasShadow={false}
              actions={actions}
              onSelect={onSelect}
            />
          ));
        }
      })}
    </StyledTableBody>
  );
};

export default ImpactClaimTableBody;
